import React, { useState } from 'react'
import axios from 'axios'
import { useHistory, useParams } from 'react-router-dom'
import FormFooter from '../../general/FormFooter';

function UpdatePassword({ loading, userInfo }) {

    const { id } = useParams();
    const history = useHistory();
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');


    const changePassword = async (e) => {
        e.preventDefault();
        if (password !== confirmPassword) {
            setTimeout(() => {
                setError('')
            }, 5000)
            setError('Password do not match with Confirm Password');
            setPassword('');
            setConfirmPassword('');
        }
        else {
            try {
                await axios.put(
                    `${process.env.REACT_APP_BACKLINK}/api/private/update-password/${id}`,
                    { password },
                    { withCredentials: true }
                );
                await axios.get(`${process.env.REACT_APP_BACKLINK}/api/auth/logout`, { withCredentials: true });
                history.push("/login");
            }
            catch (err) {
                setError(error.response.msg)
            }
        }

    }

    return (
        <>
            {loading ? <h1>Loading...</h1> :
                Object.keys(userInfo).length > 0 && !(Number(userInfo.id) === Number(id)) ? <h1>You are not authorized, Contact with your admin.</h1> :
                    <form onSubmit={changePassword} className='row'>
                        {error && <h1>{error}</h1>}
                        <div className="form-group col-sm-6">
                            <label>Password:</label>
                            <input type="password" name="password" className="form-control"
                                autoComplete="true"
                                required
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </div>
                        <div className="form-group col-sm-6">
                            <label>Confirm Password:</label>
                            <input type="password" className="form-control"
                                autoComplete="true"
                                required
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                            />
                        </div>
                        <FormFooter button="Change Password" />
                    </form>
            }

        </>
    )
}

export default UpdatePassword
